import RutasComponent from './rutas/RutasComponent.jsx';



const RutasModule = () => {


    return (
        <div className="container-fluid py-4">
            <h1 className="h3 mb-4 text-gray-800">Visor de rutas</h1>
            <div>
            </div>
            <RutasComponent />
        </div>


    );
};

export default RutasModule;